import React, {useRef} from "react";
import classNames from "classnames";
import {UncontrolledTooltip} from "reactstrap";
import "./menuItem.sass";
import {IconSource} from "../../../shared/enums/iconSource";
import Icon from "../common/icon/icon";

export interface IMenuItemProps {
  title: string;
  icon?: IconSource;
  selected?: boolean;
  scoped?: boolean;
  badgeCount?: number;
  /**
   * Screen reader text describing the badge count.
   */
  badgeLabel?: string;
  onClick?: () => void;
  testId?: string;
}

const MenuItem: React.FC<IMenuItemProps> = ({
  title,
  icon,
  selected = false,
  scoped = false,
  badgeCount,
  badgeLabel,
  onClick,
  testId
}) => {
  const badgeRef = useRef<HTMLSpanElement>(null);

  return (
    <div
      data-testid={testId}
      className={classNames("menu-item", {
        scoped: scoped,
        selected: selected
      })}
      onClick={onClick}
    >
      {icon && <Icon source={icon} />}
      {title}
      {badgeCount !== undefined && badgeCount > 0 && (
        <>
          <span
            ref={badgeRef}
            className="menu-item-badge"
            aria-hidden={!!badgeLabel}
          >
            {badgeCount}
          </span>
          {badgeLabel && (
            <>
              <span className="sr-only">{badgeLabel}</span>
              <UncontrolledTooltip
                modifiers={{
                  preventOverflow: {boundariesElement: "window"}
                }}
                fade={false}
                className="event-tooltip"
                target={badgeRef}
              >
                {badgeLabel}
              </UncontrolledTooltip>
            </>
          )}
        </>
      )}
    </div>
  );
};

export default MenuItem;
